module.exports = __webpack_public_path__ + "media/officespace-copier_ekpyjjrq_1080__D.eda3f96b.mp4";